// Admin copy of the web app's src/device/DeviceEnded.jsx (card 540f21a4); keep the two in step.
// Shown when an event-day device's access ends (card 540f21a4): the event is
// over, or the organizer revoked it. Only the device's own key was removed.
import React from 'react';
import '../Organizer/OireachtasPanel/oireachtas.css';
import '../Organizer/OireachtasPanel/organizerOireachtas.css';
import './deviceHome.css';
import { Msr, useMaterialSymbols } from '../Organizer/OireachtasPanel/symbols';

export default function DeviceEnded() {
  useMaterialSymbols();
  return (
    <div className="oir dh-page">
      <div className="dh-ended" role="alert">
        <Msr>link_off</Msr>
        <h1>This device's access has ended</h1>
        <p>The event is over, or the organizer stopped this device. To use it again, pair it again.</p>
        <a className="op-btn" href={`${process.env.REACT_APP_USER_BASE}/device`}>
          Pair this device
        </a>
      </div>
    </div>
  );
}
